{
  "validation-errors": {
    "min-length": "Мінімальна довжина має бути не менше 2",
    "max-length": "Максимальна довжина має бути не більше 50"
  },

  "create-group": {
    "trigger": "+ Створити групу",
    "title": "Вкажіть назву для нової групи",
    "close": "Відмінити",
    "placeholder": "Назва групи",
    "submit": {
      "text": "Створити групу",
      "loading": "Створюємо..."
    }
  },

  "rename-group": {
    "title": "Зміна назви групи",
    "close": "Відмінити",
    "label": "Введіть назву групи",
    "placeholder": "Назва групи",
    "submit": {
      "loading": "Зберігаємо...",
      "text": "Зберегти назву"
    }
  },

  "group-item": {
    "created-at": "Дата створення групи {{date}}",
    "invited-count-title": "Запрошено",
    "registered-count-title": "Зареєстровано"
  },

  "group-action": {
    "rename": "Перейменувати групу",
    "deactivate": "Деактивувати групу",
    "activate": "Активувати групу",
    "delete": "Видалити групу",
    "bloked-deletion": "Видалення групи недоступне: є активні учасники або дослідження"
  }
}
